module.exports = __webpack_public_path__ + "media/images/header-beauty-bf276d1e5bf7844950592b19fc055c56.png";